import type { ActiveFilters, Incident } from '@/types'

function listHit(list: string[], value: string | undefined | null): boolean {
  if (!list.length) return true
  if (value == null || value === '') return false
  const v = String(value)
  return list.some((x) => x === v || v.includes(x) || x.includes(v))
}

/** Open/investigating incidents matching active geo + entity filters. */
export function filterIncidentsByActiveFilters(
  incidents: Incident[],
  filters: ActiveFilters,
): Incident[] {
  return incidents
    .filter((i) => i.status === 'open' || i.status === 'investigating')
    .filter((inc) => incidentMatchesFilters(inc, filters))
}

export function incidentMatchesFilters(inc: Incident, filters: ActiveFilters): boolean {
  if (filters.severity.length && filters.severity.length < 4) {
    if (!filters.severity.includes(inc.sev as 0 | 1 | 2)) return false
  }

  const hay = [inc.sid, inc.con, inc.pop, inc.metric].filter(Boolean).join(' ')

  if (filters.studio.length && !listHit(filters.studio, hay)) return false
  if (filters.game.length && !listHit(filters.game, hay)) return false
  if (filters.brand.length && !listHit(filters.brand, hay)) return false
  if (filters.continent.length && !listHit(filters.continent, inc.con) && !listHit(filters.continent, inc.pop)) return false
  if (filters.country.length && !listHit(filters.country, inc.con) && !listHit(filters.country, inc.pop)) return false
  if (filters.region.length && !listHit(filters.region, inc.con) && !listHit(filters.region, inc.pop)) return false
  if (filters.city.length && !listHit(filters.city, inc.con) && !listHit(filters.city, inc.pop)) return false
  if (filters.cdnEdge.length && !listHit(filters.cdnEdge, inc.pop) && !listHit(filters.cdnEdge, inc.con)) return false
  if (filters.streamKey.length && !listHit(filters.streamKey, inc.sid)) return false
  if (filters.sourceUrl.length && !listHit(filters.sourceUrl, inc.sid)) return false
  return true
}

/** Count of open/investigating incidents after active filters. No hop synthesis. */
export function filteredOpenIncidentCount(
  incidents: Incident[],
  filters: ActiveFilters,
): number {
  return filterIncidentsByActiveFilters(incidents, filters).length
}
